export default "__VITE_ASSET__Bj8efC7m__"